import { render, staticRenderFns } from "./CdbModal.vue?vue&type=template&id=148cb349&"
import script from "./CdbModal.vue?vue&type=script&lang=js&"
export * from "./CdbModal.vue?vue&type=script&lang=js&"
import style0 from "./CdbModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports